import { useTranslation } from 'react-i18next'

import { lightPalette } from '../palette'

export function FaqSection() {
  const { t } = useTranslation()

  const items = [
    { q: t('landing.faq.q1'), a: t('landing.faq.a1') },
    { q: t('landing.faq.q2'), a: t('landing.faq.a2') },
    { q: t('landing.faq.q3'), a: t('landing.faq.a3') },
    { q: t('landing.faq.q4'), a: t('landing.faq.a4') },
    { q: t('landing.faq.q5'), a: t('landing.faq.a5') },
  ]

  return (
    <section id="duvidas" style={{ maxWidth: 900, margin: '0 auto', padding: '88px 24px' }}>
      <h2
        data-reveal=""
        style={{
          margin: '0 0 32px',
          fontSize: 'clamp(26px,3vw,38px)',
          lineHeight: 1.12,
          fontWeight: 600,
          letterSpacing: '-0.035em',
        }}
      >
        {t('landing.faq.title')}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {items.map((item) => (
          <div
            key={item.q}
            data-reveal=""
            style={{
              border: `1px solid ${lightPalette.borderDefault}`,
              borderRadius: 14,
              background: lightPalette.surface,
              padding: '22px 24px',
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
          >
            <span style={{ fontSize: 15.5, fontWeight: 700 }}>{item.q}</span>
            <span style={{ fontSize: 14.5, lineHeight: 1.65, color: lightPalette.textBody }}>
              {item.a}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
